<script>
    import { apiHost, token } from "./stores";
    let login = "";
    let password = "";

    function send() {
        const body = JSON.stringify({
            login: login.trim(),
            password: password.trim(),
        });
        fetch(`${apiHost}v1/auth/sign-in`, {
            method: "POST",
            body,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((r) => r.json())
            .then((r) => {
                if (r.success === true && r.data && r.data.token) {
                    localStorage.setItem("token", r.data.token);
                    localStorage.setItem("newAuth", true);
                    $token = r.data.token;
                    location.reload();
                }
            });
    }
</script>

<div class="auth">
    <div class="window back" />
    <div class="window">
        <div class="text-auth">Authorization</div>
        <input
            class="form-item login"
            type="text"
            placeholder="Login"
            bind:value={login}
        />
        <input
            class="form-item password"
            type="password"
            placeholder="Password"
            bind:value={password}
        />
        <button class="form-item" on:click={send}>Enter</button>
    </div>
</div>

<style>
    div.auth {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.55);
        z-index: 1000;
    }
    .auth > .window {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 50%;
        height: 40%;
        background-color: rgba(0, 0, 0);
        transform: translateX(-50%) translateY(-50%);
    }
    .auth > .window.back {
        background-color: #fff;
        box-shadow: 0 0 2vw 2vh #00f;
    }
    .auth > .window > .text-auth {
        color: #fff;
        font-size: 3vh;
        width: 100%;
        text-align: center;
        margin-top: 3vh;
    }
    .auth > .window > .form-item {
        text-align: left;
        color: #fff;
        font-size: 3vh;
        width: 70%;
        margin-top: 3vh;
        margin-left: 15%;
        background-color: #01033c;
        border-color: #1e295f;
    }
    .auth > .window > .form-item.password {
        margin-top: 1vh;
    }
    .auth > .window > .form-item::placeholder {
        background-color: #01033c;
        color: #505887;
        opacity: 1;
    }
    .auth > .window > button.form-item {
        text-align: center;
        color: #fff;
        font-size: 3vh;
        width: 40%;
        margin-top: 3vh;
        margin-left: 30%;
        background-color: #0b2073;
        border: none;
    }
    .auth > .window > button.form-item:hover {
        background-color: #183198;
    }
    .auth > .window > button.form-item:active {
        background-color: #021255;
    }
    input:autofill {
        background: #01033c;
    }
</style>
